import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { RBACService } from '../shared/rbac.service';
import { UtilsService } from '../shared/utils.service';

@Injectable({
  providedIn: 'root'
})
export class RBACGuard implements CanActivate {

  constructor(
    private rbac: RBACService,
    private utils: UtilsService
  ) {
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // Used to determine if exact permissions are required.
    const exact: boolean = route?.data?.exact ?? false;
    const redirect: string[] = route?.data?.redirect ?? ['/dashboard'];
    // Check if the user has the required permissions.
    if( !this.rbac.userCanAccess(route.data.permissions, exact) ) {
      this.rbac.showGenericAccessDeniedMessage();
      this.utils.redirectPage(redirect);
      return false;
    }
    return true;
  }

}
